<template>
  <div>
    <RefundHeader :img_header="header_image" header="เมนูรับคืนสินค้า" link_back="sell/all"/>
    <MenuRefund/>
    <Refund_wait_for_process/>
  </div>
</template>

<script>
import MenuRefund from "@/components/admin/sell/refund_product/menurefund/MenuRefund";
import Refund_wait_for_process from "@/components/admin/sell/refund_product/Refund_wait_for_process";
import RefundHeader from "@/components/admin/sell/refund_product/header_refund/RefundHeader";
import HeaderImage from "@/assets/return_refund.png";
export default {
  name: "RefundWaitForProcess",
  components: {
    RefundHeader,
    Refund_wait_for_process,
    MenuRefund
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
